import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util from '@/libs/util';
export default {
  name: 'uploadfile',
  props: {
    fileList: Array
  },
  data: function data() {
    return {
      uploadPath: process.env.VUE_APP_API + '/paperQuestion/setAudio',
      // fileList: [],
      uploadHeader: {
        token: util.cookies.get('token')
      }
    };
  },
  methods: {
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.fileList[0] = {
        name: file.name,
        url: response.data
      };
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = [];
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm('确定移除' + file.name + '？');
    },
    beforeUpload: function beforeUpload(file) {
      var isAudio = file.type === 'audio/mpeg';
      var isLt3M = file.size / 1024 / 1024 / 1024 < 3;
      console.log(file.type);

      if (!isAudio) {
        this.$message.error('上传文件只能是音频格式!');
      }

      if (!isLt3M) {
        this.$message.error('上传头像图片大小不能超过 3MB!');
      }

      return isAudio && isLt3M;
    }
  }
};